import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { MainLayout } from "../../../components/layouts/MainLayout/MainLayout";

export const AccessDenied: React.FC = () => {
  return (
    <MainLayout>
      <Box
        id="beta-access-denied"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          p: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            maxWidth: 500,
            width: "100%",
            textAlign: "center",
          }}
        >
          <Typography variant="h2" gutterBottom>
            Stratify Beta
          </Typography>
          <Typography variant="h4" gutterBottom>
            Beta Access Required
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Stratify is currently in closed beta. Access is limited to invited
            users only.
            <p>
              If you would like to be included in the beta test, please contact
              us at <a href="mailto:help@stratify-ai.io">help@stratify-ai.io</a>
            </p>
          </Typography>
        </Paper>
      </Box>
    </MainLayout>
  );
};
